import type { IClientStatusBadge, IClientsColumn, IClientsSort } from '../interfaces/clients';
import { TRANSLATIONS_CLIENTS } from '../translations/clients';
import { ClientPlanStatus, ClientsStatus } from '../types/clients';
import type { BadgeVariant } from '../types/globals';

export const CLIENTS_PAGE_SIZE = 8;

export const CLIENTS_SKELETON_ROWS = 6;

export const CLIENTS_FETCH_PAGE_SIZE = 100;

export const CLIENTS_DEFAULT_SORT: IClientsSort = { key: 'recency', direction: 'desc' };

const COLUMNS = TRANSLATIONS_CLIENTS.clientsList.columns;

export const CLIENT_STATUS_BADGE: Record<ClientsStatus, IClientStatusBadge> = {
  [ClientsStatus.Active]: { variant: 'success', labelKey: TRANSLATIONS_CLIENTS.status.active },
  [ClientsStatus.AwaitingStart]: { variant: 'neutral', labelKey: TRANSLATIONS_CLIENTS.status.awaitingStart }
};

export const CLIENT_PLAN_STATUS_BADGE: Record<ClientPlanStatus, { variant: BadgeVariant; labelKey: string }> = {
  [ClientPlanStatus.Enrolling]: {
    variant: 'pending-activation',
    labelKey: TRANSLATIONS_CLIENTS.profile.plans.status.enrolling
  },
  [ClientPlanStatus.AwaitingStart]: {
    variant: 'neutral',
    labelKey: TRANSLATIONS_CLIENTS.profile.plans.status.awaitingStart
  },
  [ClientPlanStatus.Active]: { variant: 'success', labelKey: TRANSLATIONS_CLIENTS.profile.plans.status.active }
};

export const CLIENTS_COLUMNS: Record<ClientsStatus, IClientsColumn[]> = {
  [ClientsStatus.Active]: [
    { id: 'company', labelKey: COLUMNS.company, sortKey: 'companyName' },
    { id: 'companySize', labelKey: COLUMNS.companySize, sortKey: 'workforceSize' },
    { id: 'industry', labelKey: COLUMNS.industry },
    { id: 'location', labelKey: COLUMNS.location }
  ],
  [ClientsStatus.AwaitingStart]: [
    { id: 'company', labelKey: COLUMNS.company, sortKey: 'companyName' },
    { id: 'companySize', labelKey: COLUMNS.companySize, sortKey: 'workforceSize' },
    { id: 'industry', labelKey: COLUMNS.industry },
    { id: 'location', labelKey: COLUMNS.location },
    { id: 'enrollmentWindow', labelKey: COLUMNS.enrollmentWindow, sortKey: 'enrollmentWindow' }
  ]
};
